import { throwErrorMessage } from "../../lib/error_helper";
import { fetchWithTimeout } from "../../lib/fetch_wrapper";
import { getSiteIds } from "../customerSite/customerSiteActions";
import { setResultSearchAffairAction } from "./affairActions";

export function getAffair(code, userId, customerSiteId, allSites, onSuccess) {
    return (dispatch) => {
        const minLengthOfAffairCode = 4;

        if (code.length < minLengthOfAffairCode)
            return;

        const headers = new Headers({ 'Content-Type': 'application/json' });
        fetchWithTimeout('/api/v1/affair/get_affair/', {
            method: 'POST',
            headers: headers,
            body: JSON.stringify({
                code,
                userId,
                customerSiteIds: getSiteIds(customerSiteId, allSites)
            })
        })
            .then((response) => {
                if (!response.ok)
                    throw Error(response.statusText);

                return response;
            })
            .then((response) => response.json())
            .then((affair) => {
                if (affair.affairNotFound)
                    affair = null;

                dispatch(setResultSearchAffairAction(affair));

                if (onSuccess && typeof onSuccess === "function")
                    onSuccess(affair)
            }).catch((err) => {
                console.error("Erreur : affairActions - getAffair", err);
                dispatch(throwErrorMessage({
                    errorObject: err,
                    title: "Erreur",
                    message: "Erreur lors de la récupération de l'affaire !",
                }))
            });
    }
}
